var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.call.view==_vm.call.views.contain.value)?_c('ContainView',{attrs:{"call":_vm.call}}):(_vm.call.view==_vm.call.views.speaker.value)?_c('SpeakerView',{attrs:{"call":_vm.call}}):_c('GridView',{attrs:{"call":_vm.call}})
}
var staticRenderFns = []

export { render, staticRenderFns }